module.exports = __webpack_public_path__ + "static/img/D002.298c07c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/D002.jpg
// module id = ff33
// module chunks = 1